import { useState, useEffect } from "react"
import { Button, Grid, FormControl, InputLabel, Select, MenuItem, TextField, } from "@material-ui/core"
import PostAddIcon from '@material-ui/icons/PostAdd'
import HeaderModal from "../../../global/headerModal"
import BackDrop from "./../../../global/BackDrop"
import ModalBase from "./../../../global/ModalBase"
import { FPagarLiquidacionesStyle } from "./styles"
import { ToastMessage } from "../../../global/ToastMessage"
import { useSelector, useDispatch } from "react-redux"
import { obtenerGruposClaveViajeAction, generarLiquidacionAction, generarLiquidacionConsultaAction } from "./../../../ducks/liquidacionesDuck"
import { FormatoFechaIso } from '../../../utils/FormatFecha'
import { formatDinero } from '../../../utils/formatDinero'
import { DialogMessage } from "../../../global/DialogMessage"
import { useFormik } from "formik";
import * as yup from "yup";
import useApi from "./../../../hooks/useAPI";
import { catTipoCompra } from "./../../../constant/catTipoCompra"
import { useHistory } from "react-router-dom"

const validateMenores = ({ isMenor, isInfante }) => {
    const validationSchema = yup.object({
        monto: yup
            .number("Ingresa un monto")
            .positive("Monto postivo")
            .required("Monto es requerido")
        , montoMenor: yup.number("Ingresa un monto")
        // .when([], {
        //     is: () => isMenor === true,
        //     then: yup.number("Ingresa un monto").positive("Monto postivo")
        //         .required("Monto es requerido"),
        //     otherwise: yup.number().notRequired(),
        // })
        , montoInfante: yup.number("Ingresa un monto")
        // .when([], {
        //     is: () => isInfante === true,
        //     then: yup.number("Ingresa un monto").positive("Monto postivo")
        //         .required("Monto es requerido"),
        //     otherwise: yup.number().notRequired(),
        // })
        , montoSencilla: yup.number("Ingresa un monto")
        , montoTriple: yup.number("Ingresa un monto")
    });
    return validationSchema
}

const initialValues = {
    monto: 0,
    montoMenor: 0,
    montoInfante: 0,
    montoSencilla: 0,
    montoTriple: 0,
}
const ModalFormulario = (props) => {
    const {
        open = true,
        setOpen = () => { }
    } = props;
    const { grupo, moneda, montoTotalCal } = useSelector(store => store.liquidaciones)
    const dispatch = useDispatch()
    const history = useHistory()
    const classes = FPagarLiquidacionesStyle()
    const [load, setLoad] = useState(false)
    const [tipoMoneda, setTipoMoneda] = useState(0)
    const catalogoMoneda = useApi("Catalog/MonedaProveedor")
    const [isLoad, setIsLoad] = useState(false)
    useEffect(() => {
        setTipoMoneda(moneda?.id_moneda)
    }, [moneda?.id_moneda])

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validateMenores({ isInfante: grupo?.EsInfante, isMenor: grupo?.isMenor }),
        onSubmit: (values) => {
            onSave(values)
        },
    })
    useEffect(() => {
        let payload = {
            ClaveViaje: grupo.ClaveViaje,
            IdMoneda: tipoMoneda,
            idTipoCompra: catTipoCompra.Liquidacion,
            CostoUnitarioAdulto: formik.values.monto,
            CostoUnitarioMenor: formik.values.montoMenor,
            CostoUnitarioInfante: formik.values.montoInfante,
            CostoUnitarioCuadruple: 0,
            CostoUnitarioSencilla: formik.values.montoSencilla,
            CostoUnitarioTriple: formik.values.montoTriple,
        }
        setIsLoad(true)
        dispatch(generarLiquidacionConsultaAction(payload)).then(Response => {
            setIsLoad(false)
        })
    }, [dispatch, formik.values, grupo.ClaveViaje, tipoMoneda])
    const onSave = (values) => {
        setLoad(true)
        DialogMessage.fire({
            title: '¿Esta seguro de mandar la solicitud de pago al area de finanzas?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(generarLiquidacionAction({
                    ClaveViaje: grupo.ClaveViaje,
                    idTipoCompra: catTipoCompra.Liquidacion,
                    CostoUnitarioAdulto: values.monto,
                    CostoUnitarioMenor: values.montoMenor,
                    CostoUnitarioInfante: values.montoInfante,
                    CostoUnitarioCuadruple: 0,
                    CostoUnitarioSencilla: values.montoSencilla,
                    CostoUnitarioTriple: values.montoTriple,
                    IdMoneda: tipoMoneda,
                })).then(Response => {
                    setLoad(false)
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema con el servidor",
                        });
                        return null
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: "<strong>Atención</strong>",
                            text: Response.Message,
                        });
                        return null
                    }
                    dispatch(obtenerGruposClaveViajeAction({ claveViaje: grupo.ClaveViaje }))
                    handleClose()
                    ToastMessage.fire({
                        icon: "success",
                        title: "Ingreso Correcto",
                    })
                    history.goBack()
                })
            }
        })
    }
    const handleClose = () => {
        setOpen(false)
        setLoad(false)
        setTipoMoneda(moneda?.id_moneda)
        formik.resetForm(initialValues);
    }
    const handleSelecTipoMoneda = (event) => {
        setTipoMoneda(event.target.value)
    }
    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo="Pago grupal de Liquidaciones"
            />
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                    Paquete: {grupo?.Paquete}
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                    Fecha: {FormatoFechaIso({ date: grupo?.Fecha_Viaje, formato: "dd MMMM yyyy" })}
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                    Total de pax: {grupo?.totalPasajeros}
                </Grid>
                {
                    (!isLoad) && <Grid item xs={12} style={{ textAlign: "center" }}>
                        Total a enviar: {`${formatDinero(montoTotalCal)}`}
                    </Grid>
                }
                {
                    (isLoad) && <Grid item xs={12} style={{ textAlign: "center" }}>
                        Calculando...
                    </Grid>
                }
            </Grid>
            <form onSubmit={formik.handleSubmit}>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={6}>
                        <TextField
                            required
                            id="input-Monto"
                            label="Monto unitario"
                            type="text"
                            variant="outlined"
                            name="monto"
                            value={formik.values.monto}
                            onChange={formik.handleChange}
                            error={formik.touched.monto && Boolean(formik.errors.monto)}
                            helperText={formik.touched.monto && formik.errors.monto}
                            className={classes.textField}
                        // disabled={desactivar}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <FormControl variant="outlined" className={classes.formControl}>
                            <InputLabel id="lTipoMoneda">Moneda</InputLabel>
                            <Select
                                labelId="lTipoMoneda"
                                id="STipoMoneda"
                                name="tipoMoneda"
                                value={tipoMoneda}
                                onChange={handleSelecTipoMoneda}
                                label="Moneda"
                                disabled
                            >
                                <MenuItem value="0" disabled>
                                    {"Seleccione una opción"}
                                </MenuItem>
                                {catalogoMoneda.map((moneda, index) => (
                                    <MenuItem key={moneda.IdMoneda} value={moneda.IdMoneda}>
                                        {`${moneda.Clave} - ${moneda.Descripcion}`}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    disabled={!grupo?.EsMenor}
                                    id="input-Monto-Menor"
                                    label="Monto unitario menor"
                                    type="text"
                                    variant="outlined"
                                    name="montoMenor"
                                    value={formik.values.montoMenor}
                                    onChange={formik.handleChange}
                                    error={formik.touched.montoMenor && Boolean(formik.errors.montoMenor)}
                                    helperText={formik.touched.montoMenor && formik.errors.montoMenor}
                                    className={classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    disabled={!grupo?.EsInfante}
                                    id="input-Monto-Infante"
                                    label="Monto unitario infante"
                                    type="text"
                                    variant="outlined"
                                    name="montoInfante"
                                    value={formik.values.montoInfante}
                                    onChange={formik.handleChange}
                                    error={formik.touched.montoInfante && Boolean(formik.errors.montoInfante)}
                                    helperText={formik.touched.montoInfante && formik.errors.montoInfante}
                                    className={classes.textField}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    disabled={!grupo?.EsHabSencilla}
                                    id="input-Monto-sencilla"
                                    label="Monto unitario Hab sencilla"
                                    type="text"
                                    variant="outlined"
                                    name="montoSencilla"
                                    value={formik.values.montoSencilla}
                                    onChange={formik.handleChange}
                                    error={formik.touched.montoSencilla && Boolean(formik.errors.montoSencilla)}
                                    helperText={formik.touched.montoSencilla && formik.errors.montoSencilla}
                                    className={classes.textField}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    disabled={!grupo?.EsHabTriple}
                                    id="input-Monto-Triple"
                                    label="Monto unitario Hab. Triple"
                                    type="text"
                                    variant="outlined"
                                    name="montoTriple"
                                    value={formik.values.montoTriple}
                                    onChange={formik.handleChange}
                                    error={formik.touched.montoTriple && Boolean(formik.errors.montoTriple)}
                                    helperText={formik.touched.montoTriple && formik.errors.montoTriple}
                                    className={classes.textField}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid container className={classes.containerSpacing}>
                    <Grid item xs={12} className={classes.modalBotonesCenter}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.modalBoton}
                            type="submit"
                        >
                            Guardar
                        </Button>
                    </Grid>
                </Grid>
            </form>
            <BackDrop open={load} />
        </ModalBase>
    )
}


const FPagarLiquidaciones = () => {
    const [open, setOpen] = useState(false)
    const { grupoValido } = useSelector(store => store.liquidaciones)
    const onClick = () => {
        setOpen(true)
    }
    return (
        <div>
            <Button disabled={grupoValido} variant="outlined" color="primary" onClick={onClick} endIcon={<PostAddIcon />}>
                Liquidaciones
            </Button>
            <ModalFormulario
                open={open}
                setOpen={setOpen}
            />
        </div>
    )
}
export default FPagarLiquidaciones